import { Divider, Grid, IconButton, Tooltip } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import Fab from '@material-ui/core/Fab';
import { ExpandLessRounded, ExpandMoreRounded, InfoOutlined } from '@material-ui/icons';
import styled from 'styled-components';
import { SectionTitle } from '../common';
import { CompanyBasicFormField } from '../fields';
import { useState } from 'react';

export const TargetSection = () => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);
  const handleToggleExpand = () => {
    setIsExpanded(prev => !prev);
  };
  return (
    <>
      <Grid
        container
        spacing={2}
        justify="space-between"
        alignItems="center"
        onClick={handleToggleExpand}
        style={{
          cursor: 'pointer',
          userSelect: 'none',
          transition: 'background 0.2s ease',
        }}
        onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}>
        <Grid item>
          <SectionTitle
            id="targets"
            icon={<InfoOutlined fontSize="large" style={{ color: blue[600] }} />}
            title="Targets"
            subTitle=""
          />
        </Grid>
        <Grid item style={{ paddingBottom: '10px', display: 'flex', alignItems: 'center', gap: 8 }}>
          {/* Expand / Collapse Button */}
          <Tooltip title={isExpanded ? 'Collapse section' : 'Expand section'}>
            <IconButton
              size="small"
              onClick={e => {
                e.stopPropagation();
                handleToggleExpand();
              }}>
              {isExpanded ? (
                <ExpandLessRounded color="primary" fontSize="large" />
              ) : (
                <ExpandMoreRounded color="primary" fontSize="large" />
              )}
            </IconButton>
          </Tooltip>
        </Grid>
      </Grid>

      <Divider />
      <br />

      <Grid container spacing={1} style={{ display: isExpanded ? 'flex' : 'none' }}>
        <Grid item xs={4}>
          <CompanyBasicFormField
            name="target_company_types"
            label="Target Company Types"
            helperText="Add the company target types."
            aria-readonly={true}
            rows="3"
            multiline
          />
          <br />
          <br />
        </Grid>
        <Grid item xs={4}>
          <CompanyBasicFormField
            name="target_departments"
            label="Target Departments"
            helperText="Add the company target departments."
            aria-readonly={true}
            rows="3"
            multiline
          />
          <br />
          <br />
        </Grid>
        <Grid item xs={4}>
          <CompanyBasicFormField
            name="target_user_groups"
            label="Target User Groups"
            helperText="Add the company target groups."
            aria-readonly={true}
            rows="3"
            multiline
          />
          <br />
          <br />
        </Grid>
      </Grid>
    </>
  );
};
